module.exports = __webpack_public_path__ + "static/cartoon-editor-icons.7292ff2c.png";